module.exports = __webpack_public_path__ + "img/65c0334f665ba5de3dcb15a15e37397d.png";